import { EligibleResourceType } from '@/data/subsidy/policies/interfaces';
import { ModalityTypes } from '@/models/catalog/course';
import type { FormValidationSchema } from '@/packages/subsidy/pages/refund-request/steps/resource-description/steps/catalog-form/schema';

interface CourseResourcePayloadParams {
  catalogForm: FormValidationSchema;
  resourceType: string;
}

const buildAddress = (catalogForm: FormValidationSchema) => {
  const campus = catalogForm?.campus;
  const city = catalogForm?.city;
  const state = catalogForm?.state;

  return {
    campus: campus ? `${campus.label} - ${campus.value}` : null,
    city: city?.label ?? null,
    state: state?.value?.toString() ?? null,
  };
};

export const catalogResource = ({
  catalogForm,
}: CourseResourcePayloadParams) => {
  const hasAddress =
    catalogForm?.modality === ModalityTypes.Hybrid ||
    catalogForm?.modality === ModalityTypes.InPerson;

  return {
    type: 'course',
    name:
      catalogForm?.course?.rawCourse?.course_name || catalogForm?.course?.label,
    request_reason: catalogForm?.requestReason,
    link: catalogForm?.link ?? '',
    amount: catalogForm?.amount ?? 0,
    sale_type: catalogForm?.salesType,
    data: {
      course: {
        ...(hasAddress && {
          address: buildAddress(catalogForm),
        }),
        course_type: catalogForm?.courseType,
        duration: catalogForm?.duration ?? 0,
        duration_type: catalogForm?.durationType,
        institution_name: catalogForm?.institution?.name,
        offer_identifier: catalogForm?.offerIdentifier,
        modality: catalogForm?.modality,
        period: catalogForm?.period?.value?.toString(),
        source: EligibleResourceType.Catalog,
        id: catalogForm?.course?.id ?? 0,
      },
    },
  };
};
